import {
  ArrowRightLeft,
  Building2,
  Cpu,
  Network,
  PanelsTopLeft,
  Radio,
  UsersRound,
} from "lucide-react";
import { useMemo } from "react";
import type { SidebarItem } from "@/types/navigation";
import { useIsAdmin } from "@/hooks/useAccount";
import { useAdminAccounts } from "./useAdminAccounts";
import { awaitsSetup } from "./userAccessModel";

/** Sidebar entries for the Configure section. */
export const ADMIN_NAV: SidebarItem[] = [
  {
    id: "admin-tenants",
    label: "Tenants",
    href: "/admin/tenants",
    basePath: "/admin/tenants",
    icon: Building2,
  },
  {
    id: "admin-user-profiles",
    label: "Users",
    href: "/admin/user-profiles",
    basePath: "/admin/user-profiles",
    icon: UsersRound,
  },
  {
    id: "admin-engines",
    label: "Engines",
    href: "/admin/engines",
    basePath: "/admin/engines",
    icon: Cpu,
  },
  {
    id: "admin-widgets",
    label: "Widgets",
    href: "/admin/widgets",
    basePath: "/admin/widgets",
    icon: PanelsTopLeft,
  },
  {
    id: "admin-streams",
    label: "Streams",
    href: "/admin/streams",
    basePath: "/admin/streams",
    icon: Radio,
  },
  {
    id: "admin-network-ids",
    label: "Network IDs",
    href: "/admin/network-ids",
    basePath: "/admin/network-ids",
    icon: Network,
  },
  {
    id: "admin-data-transfer",
    label: "Data Transfer",
    href: "/admin/data-transfer",
    basePath: "/admin/data-transfer",
    icon: ArrowRightLeft,
  },
];

/**
 * The Administration sidebar with the number of accounts awaiting setup next to
 * Users, so a new sign-in is noticed without opening the list. Accounts are only
 * read for administrators.
 */
export function useAdminNav(): SidebarItem[] {
  const isAdmin = useIsAdmin();
  const accounts = useAdminAccounts(isAdmin);
  const awaiting = (accounts.data ?? []).filter(awaitsSetup).length;
  return useMemo(
    () =>
      awaiting
        ? ADMIN_NAV.map((item) =>
            item.id === "admin-user-profiles" ? { ...item, badge: String(awaiting) } : item,
          )
        : ADMIN_NAV,
    [awaiting],
  );
}
